import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-booking_list",
  "use": "icon-booking_list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-booking_list\"><defs><style></style></defs><path d=\"M663.273 337.455v349.09H360.727v-349.09h302.546m34.909-34.91H325.818v418.91h372.364z\" /><path d=\"M616.727 442.182H500.364v23.273h116.363v-23.273zm-162.909-11.637h-46.545v46.546h46.545v-46.546zm162.91 128H500.363v23.273h116.363v-23.273zm-162.91-11.636h-46.545v46.546h46.545v-46.546z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/booking_list.svg
// module id = OPbc
// module chunks = 78